import { useContext } from "react";
import { ThemeProviderContext } from "./internal/ThemeProviderContext";

export const useTheme = () => {
  return useContext(ThemeProviderContext);
};
